<div class="infigo-search-box"></div>
<div class="infigo-input">
    <input #inputElement
        (blur)="blur()"
        (focus)="focus()"
        (input)="searchValue($event.target.value)"
        (scroll)="scrollListen($event)"
        [ngClass]="{'infigo-search':true,'border-bottom':!visible || !tipData.length}"
        [value]="currentValue"
        type="text" />
    <div class="infigo-input-placeholder" *ngIf="!isBlankValue && placeholderVisible">{{ placeholderText }}</div>
    <div *ngIf="error||inputTip" class="input-display">
        <app-infigo-error-display #errorDisplayComponent
            (onTimeSelectChange)="onTimeSelectChange($event)"
            [error]="error"
            [isFocus]="slideDown"
            [tip]="inputTip"
            [value]="currentValue">
        </app-infigo-error-display>
    </div>
    <div class="right-abs">
        <svg (click)="clearValue()" *ngIf="currentValue" class="icon close">
            <use xlink:href="#infigo-close"></use>
        </svg>
        <div class="line"></div>
        <svg (click)="collect()" *ngIf="!collected"
            [nTooltip]="collectable && !error?i18n.get('home.search_term_favorite_tip'):error?i18n.get('home.search_term_favor_err_info'):i18n.get('home.search_term_inputAndfavor_info')"
            [ngStyle]="{'color': collectable && !error?'#FDCA5A':'#9EA4B3'}" class="icon collect" nTooltipPlacement="top">
            <use xlink:href="#infigo-collect"></use>
        </svg>
        <svg (click)="collect()" *ngIf="collected" [nTooltip]="i18n.get('home.search_term_cancelFavor_lab')"
            class="icon collect"
            nTooltipPlacement="top">
            <use xlink:href="#infigo-collected"></use>
        </svg>
        <svg (click)="shrink()" [nTooltip]="i18n.get('home.search_term_liteMode_lab')" class="icon shrink"
            nTooltipPlacement="top">
            <use xlink:href="#infigo-shrink"></use>
        </svg>
        <n-help-link [key]="'globalsearch'"></n-help-link>
    </div>
    <ul (mouseenter)="enter()"
        (mouseleave)="leave()"
        [hidden]="!(visible && tipData.length)"
        [@SlideDownMotion]="slideDown ? 'fill' : 'void'"
        class="input-tip">
        <div [hidden]="!tipData.length">
            <div *ngIf="tipShow" class="tip-close">{{i18n.get('home.search_term_conditionSearch_info')}}
                <span (click)="hidden($event)">{{i18n.get('home.quickstart_task_noNoticeAgain_checkbox')}}</span>
            </div>
            <div #tipElement class="tip-element" [ngStyle]="{'pointer-events': visible ? 'auto' : 'none'}">
                <li (click)="autoComplete(item)" *ngFor="let item of tipData;let i=index;trackBy: tipTrackBy;"
                    [ngClass]="{'input-tip-item':true,select:select===i}">
                    <span class="tip-content normal">{{item.normal}}</span>
                    <span class="tip-content emphasis">{{item.emphasis}}</span>
                    <svg *ngIf="showSpace(item)" [ngStyle]="{color:select===i ?'#ffffff':'#B8BECC'}" class="icon-space">
                        <use xlink:href="#infigo-space"></use>
                    </svg>
                    <span class="tip-content tip">{{item.tip}}</span>
                </li>
            </div>
        </div>
    </ul>
</div>
